<template>
  <div class="booking-search-list">
    <div v-if="bookingSearchListByDate && bookingSearchListByDate.length > 0">
      <div
        v-for="(
          bookingSearchByDate, bookingSearchByDateIndex
        ) in bookingSearchListByDate"
        :key="bookingSearchByDateIndex"
        class="booking-date"
      >
        <div>
          <div class="mb-2 mt-2 date-select">
            <div class="date">{{ bookingSearchByDate.dateSelect }}</div>
            <div
              v-if="
                bookingSearchByDate.conferenceProjectListByDate &&
                bookingSearchByDate.conferenceProjectListByDate.length > 0
              "
              class="count-by-date"
            >
              พบ {{ bookingSearchByDate.conferenceProjectListByDate.length }} รายการ
            </div>
          </div>
          <div>
            <div
              v-if="
                bookingSearchByDate.conferenceProjectListByDate &&
                bookingSearchByDate.conferenceProjectListByDate.length > 0
              "
            >
              <booking-items
                :conferenceProjectList="bookingSearchByDate.conferenceProjectListByDate"
                class="booking-item mb-5"
              ></booking-items>
            </div>

            <div v-else class="empty mb-5">
              <div class="empty-box">ไม่พบห้องว่าง</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingItems from "./BookingItems";

export default {
  components: {
    "booking-items": BookingItems,
  },
  props: ["bookingSearchListByDate"],
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.booking-date {
  border-top: 4px solid $color-orange;
  min-height: 100px;
  border-radius: 5px;
}

.date-select {
  display: flex;
  justify-content: space-between;
}

.date {
  color: $color-orange;
  font-weight: bold;
  font-size: $font-22;
}

.booking-item {
  padding-left: 15px;
  padding-right: 15px;
}

.empty {
  position: relative;
  height: 100px;
  background-color: $white;
  border-radius: 8px;
}

.empty-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/BookingSearchList.vue